import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HiLanguage } from 'react-icons/hi2';
import { SiGithub, SiVelog } from 'react-icons/si';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import {
  DEFAULT_LANGUAGE,
  BLACK_LANGUAGES,
  WHITE_LANGUAGES,
} from '@/utils/langUtils';
import { getCountryLang } from '@/utils/langUtils';
import LanguageChangeButtonModal from '@modal/modal_languageChange';

const FooterBody = styled.div`
  width: 100%;
  margin-top: 5rem;
  padding: 0.5rem;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  background-color: var(--main2-bg-color);
  gap: 10px;
  color: gray;
  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
  & a {
    text-decoration: none;
    -webkit-tap-highlight-color: transparent !important;
  }
`;

const ContainerLink = styled.div`
  display: flex;
  gap: 20px;

  & svg {
    color: gray;
    font-size: 24px;
  }

  & > button {
    padding: 0;
    color: gray;
    display: flex;
    align-items: center;
    & > svg {
      font-size: 24px;
    }
    &:hover {
      & > * {
        color: var(--point1-color);
      }
    }
  }
`;

const Footer = () => {
  const { t, i18n } = useTranslation();
  const { language: curLang } = i18n;
  const [currentLang, setCurrentLang] = useState('');

  useEffect(() => {
    let text;
    if (WHITE_LANGUAGES.includes(curLang)) {
      text = getCountryLang(t, curLang);
    } else if (BLACK_LANGUAGES.includes(curLang)) {
      text = `${getCountryLang(t, curLang)}(${t('not_supported')})`;
    } else {
      text = getCountryLang(t, DEFAULT_LANGUAGE, DEFAULT_LANGUAGE);
    }
    setCurrentLang(text);
  }, [curLang]);

  return (
    <FooterBody>
      <span>© 2023 Lee Hye Won. All rights reserved.</span>
      <span>
        icons by <a href="https://icons8.com">Icons8</a>
      </span>
      <ContainerLink>
        <Link target="_blank" to="https://github.com/dev-hyewon">
          <SiGithub />
        </Link>
        <Link target="_blank" to="https://velog.io/@dev-hyewon">
          <SiVelog />
        </Link>
        <LanguageChangeButtonModal>
          <HiLanguage />
          <b>{currentLang}</b>
        </LanguageChangeButtonModal>
      </ContainerLink>
    </FooterBody>
  );
};

export default Footer;
